var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('query-form',{staticClass:"form",on:{"query":_vm.query,"reset":_vm.resetQuery}}),_c('activity-table',{ref:"mainTable",staticClass:"themeTable"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }